<script>
export default {
  props: ['text'],
  data: () => ({
    isFocus: false,
    query: '',
  }),
  methods: {
    submitQuery() {
      this.$emit('submitted', this.query);
    },
  },
};
</script>

<template>
  <form
    :title="text"
    @submit.prevent="submitQuery"
    :class="{ 'is--focused': isFocus }"
    class="search--input--container form-control"
    ref="search">
    <input
      autocomplete="off"
      type="text"
      :alt="text"
      :title="text"
      :name="text"
      v-model="query"
      @focus="isFocus = true"
      @blur="isFocus = false"
      :placeholder="text"
      @input="submitQuery" />
    <transition name="fade" mode="in-out">
      <button
        type="submit"
        v-if="!isFocus"
        class="d-flex align-items-center justify-content-center search--btn">
        <span class="material-icons">search</span>
      </button>
      <button
        type="submit"
        v-else
        class="d-flex search--btn align-items-center active justify-content-center">
        <span class="material-icons blue">search</span>
      </button>
    </transition>
  </form>
</template>
